import type { CuratedStory, Image, Video } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
    INTEGRITY_FAIL_MEDIA,
} from "~utils/moduleIntegrity";

interface SingleStoryUkDefaultIntegrityProps {
    items?: CuratedStory[];
    image?: Image;
    embedUrl?: string;
    video?: Video;
}

export default function integrityCheck({
    items = [],
    image,
    embedUrl,
    video,
}: SingleStoryUkDefaultIntegrityProps): IntegrityStatus {
    const messages = checkItemArrayIntegrity(items);

    if (items?.length) {
        const [content] = items;

        const { eyebrow, image: contentImage } = content;

        // This variation needs some form of multimedia to be valid.
        if (!(embedUrl || image?.baseUrl || contentImage?.baseUrl || video)) {
            messages.push(INTEGRITY_FAIL_MEDIA);
        }

        if (!eyebrow) messages.push("Missing eyebrow");
    }

    return messages;
}
